import { render } from "./BannerHengxing.vue?vue&type=template&id=1c2b05a2&scoped=true"
import script from "./BannerHengxing.vue?vue&type=script&lang=js"
export * from "./BannerHengxing.vue?vue&type=script&lang=js"

import "./BannerHengxing.vue?vue&type=style&index=0&id=1c2b05a2&scoped=true&lang=css"

import exportComponent from "/workspace/wum/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2b05a2"]])

export default __exports__